import { BillerNetworkAccountConstants as Constants } from '../types'
import { billerNetworkAccountApi as api } from '../../api'

export const billerNetworkAccountAction = {
    get,
}

function get(filters = {}) {
    return dispatch => {
        dispatch({ type: Constants.LOADING })
        return new Promise((resolve, reject) => {
            api._get(filters)
                .then(
                    payload => {
                        dispatch({ type: Constants.GET, payload })
                        resolve(payload)
                    },
                    error => {
                        dispatch({ type: Constants.FAIL, error })
                        reject(error)
                    }
                )
        })
    }
}
